import { Injectable } from '@angular/core';
import { BaseService } from '../../../core/service/base.service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs/index';
import { PageData } from '../../../core/bean/page-data';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
@Injectable({
  providedIn: 'root',
})

export class JyExtendOverrideService extends BaseService {

  subject = new Subject<any>();

  send(message: any) {
    this.subject.next(message);
  }

  get(): Observable<any> {
    return this.subject.asObservable();
  }
  HEADER_NAME_TOTALCOUNT = 'X-Total-Count';
  private url = 'api/workflowOverrideRequest';        //待办流程
  constructor(http: HttpClient) {
    super(http);
  }
  getUrl(): string {
    return this.url;
  }

  //  发送待办消息
  sendBackLogOverride(): Observable<any> {
    return this.http.post<any>('api/workflowOverrideRequest/getPendingMsg', {}, httpOptions).pipe(
      tap((object: any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany')),
    );
  }


}
